import React from "react";
import "../styles/ProductsPage.css";

const ProductsPage = () => {
  return (
    <div className="products-page">

      {/* =======================================================
          HERO
      ======================================================= */}

      <section className="products-hero">
        <div className="hero-light"></div>

        <div className="hero-content">
          <span className="hero-eyebrow">
            AI • Healthcare • Automation • Innovation
          </span>

          <h1>
            Innovative AI Platforms for Better Healthcare and Smarter
            Organisations
          </h1>

          <p>
            Explore TechnovaShield&apos;s growing portfolio of responsible AI
            platforms, healthcare data solutions, intelligent automation and
            digital wellbeing innovations designed to help organisations
            innovate responsibly, improve operational performance and build
            trusted digital capabilities.
          </p>
        </div>
      </section>

      {/* =======================================================
          01 — CareSentinelAI
      ======================================================= */}

      <section
        id="caresentinelai"
        className="product-section"
      >
        <div className="product-content">

          <div className="product-text">
            <div className="section-number">01</div>

            <h2>CareSentinelAI</h2>

            <h3>Clinical Intelligence Platform</h3>

            <p>
              CareSentinelAI is TechnovaShield&apos;s flagship healthcare AI
              platform, designed to support clinicians by identifying patients
              requiring timely review, highlighting clinical deterioration and
              improving care coordination through responsible, explainable
              artificial intelligence.
            </p>

            <p>
              Built with clinicians in mind, the platform focuses on delivering
              meaningful insights rather than overwhelming users with data,
              helping healthcare professionals make faster, more informed
              clinical decisions.
            </p>

            <div className="capability-heading">
              Key Capabilities
            </div>

            <div className="capability-chips">
              <span>Explainable AI</span>
              <span>Clinical Decision Support</span>
              <span>Live Monitoring</span>
              <span>Early Risk Detection</span>
              <span>Workflow Integration</span>
              <span>Scalable Platform</span>
            </div>
          </div>

          <div className="product-media">
            <video
              className="product-video"
              autoPlay
              muted
              loop
              playsInline
              controls
              preload="auto"
            >
              <source
                src="/Videos/CareSentinelAI_Flow_Video_V3.mp4"
                type="video/mp4"
              />

              Your browser does not support the video tag.
            </video>
          </div>

        </div>
      </section>

      {/* =======================================================
          02 — CareSentinelAI Enterprise Dataset
      ======================================================= */}

      <section
        id="enterprise-dataset"
        className="product-section alternate"
      >
        <div className="product-content reverse">

          <div className="product-media">
            <video
              className="product-video"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            >
              <source
                src="/CareSentinelAI.mp4"
                type="video/mp4"
              />

              Your browser does not support the video tag.
            </video>
          </div>

          <div className="product-text">
            <div className="section-number">02</div>

            <h2>CareSentinelAI Enterprise Dataset</h2>

            <h3>Healthcare Synthetic Data Programme</h3>

            <p>
              The CareSentinelAI Enterprise Dataset Programme has been developed
              to support responsible healthcare AI innovation through the
              creation of high-quality, privacy-preserving synthetic clinical
              datasets.
            </p>

            <p>
              Designed specifically for healthcare research, software
              development, AI model validation and digital innovation, the
              programme focuses on maintaining clinical realism while protecting
              patient privacy and supporting reproducible, trustworthy AI
              development.
            </p>

            <div className="ideal-for">
              <div className="ideal-for-heading">
                Ideal For
              </div>

              <p className="ideal-for-text">
                Healthcare AI developers, health technology companies,
                universities and research organisations, clinical software
                vendors, and organisations requiring realistic clinical data
                for development and validation without exposing identifiable
                patient information.
              </p>
            </div>

            <div className="capability-heading">
              Key Capabilities
            </div>

            <div className="capability-chips">
              <span>Privacy-Preserving Data</span>
              <span>Clinical Validation</span>
              <span>Reproducible Datasets</span>
              <span>Traceability</span>
              <span>Responsible AI</span>
              <span>Data Quality Assurance</span>
            </div>
          </div>

        </div>
      </section>

      {/* =======================================================
          03 — Synthetic Data Generation Services
      ======================================================= */}

      <section
        id="synthetic-data"
        className="product-section"
      >
        <div className="product-content">

          <div className="product-text">
            <div className="section-number">03</div>

            <h2>Synthetic Data Generation Services</h2>

            <h3>
              Privacy-Preserving Data Solutions for AI Innovation
            </h3>

            <p>
              TechnovaShield provides synthetic data generation services that
              enable organisations to accelerate AI development, software
              testing, analytics, research and innovation without relying on
              sensitive real-world data.
            </p>

            <p>
              Our approach focuses on creating realistic, privacy-preserving
              datasets that retain the characteristics required for development
              and validation while supporting strong data governance, security
              and responsible AI practices across multiple industries.
            </p>

            <div className="ideal-for">
              <div className="ideal-for-heading">
                Ideal For
              </div>

              <p className="ideal-for-text">
                Organisations developing AI, analytics and digital products,
                software teams requiring realistic test data, research groups,
                government and regulated industries, and organisations where
                access to real-world data is constrained by privacy, security,
                governance, availability or scarcity.
              </p>
            </div>

            <div className="capability-heading">
              Key Capabilities
            </div>

            <div className="capability-chips">
              <span>Healthcare</span>
              <span>Government</span>
              <span>Research</span>
              <span>AI Development</span>
              <span>Software Testing</span>
              <span>Analytics</span>
              <span>Digital Twins</span>
              <span>Privacy by Design</span>
            </div>

            <a
              href="/contact"
              className="product-button"
            >
              Discuss Your Data Requirements
            </a>
          </div>

          <div className="product-media">
            <video
              className="product-video"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            >
              <source
                src="/Synthetic.mp4"
                type="video/mp4"
              />

              Your browser does not support the video tag.
            </video>
          </div>

        </div>
      </section>

      {/* =======================================================
          04 — Intelligent Automation
      ======================================================= */}

      <section
        id="intelligent-automation"
        className="product-section alternate"
      >
        <div className="product-content reverse">

          <div className="product-media">
            <video
              className="product-video"
              autoPlay
              muted
              loop
              playsInline
              controls
              preload="auto"
            >
              <source
                src="/Videos/EcommerceKiwiMall-video.mp4"
                type="video/mp4"
              />

              Your browser does not support the video tag.
            </video>
          </div>

          <div className="product-text">
            <div className="section-number">04</div>

            <h2>Intelligent Automation</h2>

            <h3>
              AI-Powered Workflow &amp; Business Process Automation
            </h3>

            <p>
              TechnovaShield helps organisations improve operational efficiency
              by combining intelligent automation, artificial intelligence and
              modern workflow technologies to automate repetitive processes
              while keeping people in control of critical business decisions.
            </p>

            <p>
              Our automation solutions are designed to reduce manual effort,
              improve accuracy, accelerate service delivery and support digital
              transformation across healthcare, professional services and
              enterprise environments.
            </p>

            <div className="capability-heading">
              Key Capabilities
            </div>

            <div className="capability-chips">
              <span>UiPath Automation</span>
              <span>Document Processing</span>
              <span>Workflow Optimisation</span>
              <span>AI-Assisted Processes</span>
              <span>Human-in-the-Loop</span>
              <span>Operational Efficiency</span>
            </div>

            <a
              href="/contact"
              className="product-button"
            >
              Explore Automation Solutions
            </a>
          </div>

        </div>
      </section>

      {/* =======================================================
          05 — MindfulAI
      ======================================================= */}

      <section
        id="mindfulai"
        className="product-section"
      >
        <div className="product-content">

          <div className="product-text">
            <div className="section-number">05</div>

            <h2>MindfulAI</h2>

            <h3>
              AI-Powered Digital Wellbeing Platform
            </h3>

            <p>
              MindfulAI is TechnovaShield&apos;s digital wellbeing initiative
              exploring how artificial intelligence can support healthier
              lifestyles through guided mindfulness, relaxation, stress
              management and improved sleep experiences.
            </p>

            <p>
              Designed with a people-first approach, the platform aims to
              complement broader healthcare ecosystems by encouraging positive
              wellbeing habits, personalised guidance and future integration
              with emerging digital health technologies.
            </p>

            <div className="capability-heading">
              Key Capabilities
            </div>

            <div className="capability-chips">
              <span>Guided Mindfulness</span>
              <span>Stress Management</span>
              <span>Sleep Support</span>
              <span>Personalised Sessions</span>
              <span>Digital Wellbeing</span>
              <span>Future Wearable Integration</span>
            </div>

            <a
              href="/contact"
              className="product-button"
            >
              Learn More
            </a>
          </div>

          <div className="product-media">
            <video
              className="product-video"
              autoPlay
              muted
              loop
              playsInline
              controls
              preload="auto"
            >
              <source
                src="/Videos/Meditation-video.mp4"
                type="video/mp4"
              />

              Your browser does not support the video tag.
            </video>
          </div>

        </div>
      </section>

      {/* =======================================================
          CALL TO ACTION
      ======================================================= */}

      <section className="products-cta">
        <div className="products-cta-content">

          <span className="cta-eyebrow">
            Partner with TechnovaShield
          </span>

          <h2>
            Building a Healthier, Smarter and More Secure Tomorrow
          </h2>

          <p>
            Whether you&apos;re exploring healthcare AI, synthetic data,
            intelligent automation or digital wellbeing solutions,
            TechnovaShield partners with organisations to transform innovative
            ideas into practical, responsible and scalable digital solutions.
          </p>

          <div className="cta-buttons">

            <a
              href="/contact"
              className="primary-btn"
            >
              Discuss Your Project
            </a>

            <a
              href="/about"
              className="secondary-btn"
            >
              Learn More About Us
            </a>

          </div>
        </div>
      </section>

    </div>
  );
};

export default ProductsPage;